module.exports = __webpack_public_path__ + "img/marina_bg.14f7ed25.jpeg";